import React, { useState } from "react";
import GameChat from "./GameChat";
import GameLogPopup from "../game/GameLogPopup";
import "../../styling/game-chat.css";

const TAB_CHAT = "chat";
const TAB_LOG = "log";

/**
 * Panel that toggles between Chat and Game Log in the same slot.
 */
const ChatOrGameLogPanel = ({
  socket,
  room,
  name,
  playerColors,
  playerEmojis,
  messages = [],
  gameLog = [],
  updates = [],
}) => {
  const [activeTab, setActiveTab] = useState(TAB_CHAT);

  return (
    <div className="game-chat-container game-chat-expanded chat-or-log-panel">
      <div className="chat-or-log-header">
        <button
          type="button"
          className={`chat-or-log-tab ${activeTab === TAB_CHAT ? "active" : ""}`}
          onClick={() => setActiveTab(TAB_CHAT)}
        >
          💬 Chat
        </button>
        <button
          type="button"
          className={`chat-or-log-tab ${activeTab === TAB_LOG ? "active" : ""}`}
          onClick={() => setActiveTab(TAB_LOG)}
          data-tutorial="game-log"
        >
          📊 Game Log
        </button>
      </div>
      <div className="game-chat-content chat-or-log-content">
        {activeTab === TAB_CHAT && (
          <GameChat
            socket={socket}
            room={room}
            name={name}
            playerColors={playerColors}
            playerEmojis={playerEmojis}
            messages={messages}
            showHeader={false}
          />
        )}
        {activeTab === TAB_LOG && (
          <div className="chat-or-log-inline">
            <GameLogPopup gameLog={gameLog} updates={updates} playerColors={playerColors} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatOrGameLogPanel;
